<template>
  <div class="send-sms-tab">
    <a-radio-group v-model="activeSubTab" class="send-sms-type-switch">
      <a-radio value="phone">自定义手机号发送短信</a-radio>
      <a-radio value="user">发送给用户</a-radio>
    </a-radio-group>

    <div class="send-sms-content">
      <a-card v-show="activeSubTab === 'user'" title="发送短信" :bordered="true" class="send-sms-card">
        <a-form-model
          ref="userForm"
          :model="userForm"
          :rules="userRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="选择模板" prop="templateId">
            <a-select
              v-model="userForm.templateId"
              allow-clear
              placeholder="请选择"
              style="width: 100%"
              :loading="templateLoading"
              @change="onUserTemplateChange"
            >
              <a-select-option
                v-for="item in enabledTemplateOptions"
                :key="item.id"
                :value="item.id"
              >
                {{ item.templateName }}
              </a-select-option>
            </a-select>
            <div v-if="userPreviewText" class="preview-text">
              预览模板：{{ userPreviewText }}
            </div>
          </a-form-model-item>

          <a-form-model-item label="选择发送用户" prop="tagId">
            <a-select
              v-model="userForm.tagId"
              placeholder="请选择"
              style="width: 100%"
              :loading="memberTagLoading"
            >
              <a-select-option
                v-for="item in memberTagOptions"
                :key="item.tagId"
                :value="item.tagId"
              >
                {{ item.tagName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item
            v-for="key in userTemplateVars"
            :key="'user-' + key"
            :label="key"
            :prop="'contentVar.' + key"
            :rules="[{ required: true, message: `请输入${key}`, trigger: 'blur' }]"
          >
          <a-textarea
              v-if="isTextareaVar(key)"
              v-model="userForm.contentVar[key]"
              allow-clear
              :rows="3"
              placeholder="请输入"
            />
            <a-input
              v-else
              v-model="userForm.contentVar[key]"
              allow-clear
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-form-model>

        <div class="send-sms-footer">
          <a-button @click="handleUserReset">取消</a-button>
          <a-button type="primary" :loading="submitting" @click="handleUserSubmit">确定</a-button>
        </div>
      </a-card>

      <a-card v-show="activeSubTab === 'phone'" title="发送短信" :bordered="true" class="send-sms-card">
        <a-form-model
          ref="phoneForm"
          :model="phoneForm"
          :rules="phoneRules"
          :label-col="labelCol"
          :wrapper-col="wrapperCol"
        >
          <a-form-model-item label="选择模板" prop="templateId">
            <a-select
              v-model="phoneForm.templateId"
              allow-clear
              placeholder="请选择"
              style="width: 100%"
              :loading="templateLoading"
              @change="onPhoneTemplateChange"
            >
              <a-select-option
                v-for="item in enabledTemplateOptions"
                :key="item.id"
                :value="item.id"
              >
                {{ item.templateName }}
              </a-select-option>
            </a-select>
            <div v-if="phonePreviewText" class="preview-text">
              预览模板：{{ phonePreviewText }}
            </div>
          </a-form-model-item>

          <a-form-model-item label="接收手机号" prop="phoneNumbers">
            <a-input
              v-model="phoneForm.phoneNumbers"
              allow-clear
              placeholder="请输入手机号"
            />
          </a-form-model-item>

          <a-form-model-item
            v-for="key in phoneTemplateVars"
            :key="'phone-' + key"
            :label="key"
            :prop="'contentVar.' + key"
            :rules="[{ required: true, message: `请输入${key}`, trigger: 'blur' }]"
          >
          <a-textarea
              v-if="isTextareaVar(key)"
              v-model="phoneForm.contentVar[key]"
              allow-clear
              :rows="3"
              placeholder="请输入"
            />
            <a-input
              v-else
              v-model="phoneForm.contentVar[key]"
              allow-clear
              placeholder="请输入"
            />
          </a-form-model-item>
        </a-form-model>

        <div class="send-sms-footer">
          <a-button @click="handlePhoneReset">取消</a-button>
          <a-button type="primary" :loading="submitting" @click="handlePhoneSubmit">确定</a-button>
        </div>
      </a-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SendSmsTab',
  data () {
    const phoneValidator = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
        return
      }
      if (!/^1[3-9]\d{9}$/.test(String(value).trim())) {
        callback(new Error('请输入正确的手机号'))
        return
      }
      callback()
    }
    return {
      activeSubTab: 'phone',
      submitting: false,
      memberTagLoading: false,
      templateLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      userForm: {
        templateId: undefined,
        tagId: undefined,
        contentVar: {}
      },
      phoneForm: {
        templateId: undefined,
        phoneNumbers: undefined,
        contentVar: {}
      },
      userRules: {
        templateId: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ],
        tagId: [
          { required: true, message: '请选择发送用户', trigger: 'change' }
        ]
      },
      phoneRules: {
        templateId: [
          { required: true, message: '请选择模板', trigger: 'change' }
        ],
        phoneNumbers: [
          { required: true, validator: phoneValidator, trigger: 'blur' }
        ]
      },
      memberTagOptions: [],
      templateOptions: []
    }
  },
  computed: {
    enabledTemplateOptions () {
      return this.templateOptions.filter(item => Number(item.status) === 1)
    },
    userPreviewText () {
      const item = this.enabledTemplateOptions.find(row => row.id === this.userForm.templateId)
      return item ? item.templateContent : ''
    },
    phonePreviewText () {
      const item = this.enabledTemplateOptions.find(row => row.id === this.phoneForm.templateId)
      return item ? item.templateContent : ''
    },
    userTemplateVars () {
      return this.extractTemplateVars(this.userPreviewText)
    },
    phoneTemplateVars () {
      return this.extractTemplateVars(this.phonePreviewText)
    }
  },
  created () {
    this.loadTemplateOptions()
    this.loadMemberTagOptions()
  },
  methods: {
    extractTemplateVars (content) {
      if (!content) {
        return []
      }
      const matches = String(content).match(/\$\{([^}]+)\}/g) || []
      const keys = matches.map(item => item.slice(2, -1))
      return [...new Set(keys)]
    },
    isTextareaVar (key) {
      return ['msg','message','address'].includes(String(key).toLowerCase())
    },
    initContentVar (form, keys) {
      const contentVar = {}
      keys.forEach(key => {
        contentVar[key] = ''
      })
      this.$set(form, 'contentVar', contentVar)
    },
    onUserTemplateChange () {
      this.initContentVar(this.userForm, this.userTemplateVars)
    },
    onPhoneTemplateChange () {
      this.initContentVar(this.phoneForm, this.phoneTemplateVars)
    },
    loadTemplateOptions () {
      this.templateLoading = true
      this.getHttpServices().getNewServeService()
        .post('/smsTemplate/pageByMerchant', {
          limitDto: {
            pageNum: 1,
            pageSize: 500
          }
        })
        .then(res => {
          this.templateOptions = (res && res.data) || []
        })
        .catch(err => {
          this.templateOptions = []
          this.showNetWorkErrorMessage(err)
        })
        .finally(() => {
          this.templateLoading = false
        })
    },
    loadMemberTagOptions () {
      this.memberTagLoading = true
      this.getHttpServices().getNewServeService()
        .post('/smsRecord/memberTagList')
        .then(list => {
          this.memberTagOptions = Array.isArray(list) ? list : []
        })
        .catch(err => {
          this.memberTagOptions = []
          this.showNetWorkErrorMessage(err)
        })
        .finally(() => {
          this.memberTagLoading = false
        })
    },
    handleUserReset (keepTemplate = false) {
      const templateId = this.userForm.templateId
      this.userForm = {
        templateId: keepTemplate ? templateId : undefined,
        tagId: undefined,
        contentVar: {}
      }
      // 保留模板时重新初始化模板变量输入框
      if (keepTemplate) {
        this.onUserTemplateChange()
      }
      this.$nextTick(() => {
        if (this.$refs.userForm) {
          this.$refs.userForm.clearValidate()
        }
      })
    },
    handlePhoneReset (keepTemplate = false) {
      const templateId = this.phoneForm.templateId
      this.phoneForm = {
        templateId: keepTemplate ? templateId : undefined,
        phoneNumbers: undefined,
        contentVar: {}
      }
      // 保留模板时重新初始化模板变量输入框
      if (keepTemplate) {
        this.onPhoneTemplateChange()
      }
      this.$nextTick(() => {
        if (this.$refs.phoneForm) {
          this.$refs.phoneForm.clearValidate()
        }
      })
    },
    handleUserSubmit () {
      this.$refs.userForm.validate(valid => {
        if (!valid) {
          return
        }
        this.submitting = true
        this.getHttpServices().getNewServeService()
          .post('/smsRecord/sendMemberTagMsg', {
            tagId: this.userForm.tagId,
            templateId: this.userForm.templateId,
            contentVar: this.userForm.contentVar || {}
          })
          .then(() => {
            this.$message.success('发送成功')
            this.handleUserReset(true)
          })
          .catch(err => this.showNetWorkErrorMessage(err))
          .finally(() => {
            this.submitting = false
          })
      })
    },
    handlePhoneSubmit () {
      this.$refs.phoneForm.validate(valid => {
        if (!valid) {
          return
        }
        const phones = String(this.phoneForm.phoneNumbers || '')
          .split(/[,，\s]+/)
          .map(item => item.trim())
          .filter(Boolean)
        this.submitting = true
        this.getHttpServices().getNewServeService()
          .post('/smsRecord/sendPhoneMsg', {
            templateId: this.phoneForm.templateId,
            phones,
            contentVar: this.phoneForm.contentVar || {}
          })
          .then(() => {
            this.$message.success('发送成功')
            this.handlePhoneReset(true)
          })
          .catch(err => this.showNetWorkErrorMessage(err))
          .finally(() => {
            this.submitting = false
          })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.send-sms-tab {
  width: 100%;
}

.send-sms-type-switch {
  margin-bottom: 16px;
}

.send-sms-content {
  display: flex;
  justify-content: center;
}

.send-sms-card {
  width: 100%;
  max-width: 720px;
}

.preview-text {
  margin-top: 8px;
  color: rgba(0, 0, 0, 0.45);
  line-height: 1.6;
}

.send-sms-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 8px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>
